/**
 * Advice-card ids are product-owned — not CMS-listed.
 * CMS `adviceCards` may only supply optional chrome (title / body / colors) by id.
 */
import type { AdviceCard } from '../../types/adviceCards.types'
import { ELITE_PLANS_ELITE_PRIME_TAB_ID } from '../../constants/planIds'

/** Elite tab order. Visibility is gated by eliteInsights keys in each card renderer. */
export const ELITE_ADVICE_CARD_IDS = [
  'rebalance-plan',
  'tax-summary',
  'regular-to-direct-plan'
] as const

/** Elite Prime tab order. Visibility is gated by prime / elite insights keys. */
export const ELITE_PRIME_ADVICE_CARD_IDS = [
  'allocation-plan',
  'ideal-portfolio',
  'sip-plan',
  'lump-sum-investment-plan',
  'ideal-sip-plan',
  'rebalance-plan',
  'regular-to-direct-plan',
  'tax-summary'
] as const

/** Builds the carousel list from the local catalog; CMS chrome is overlay-only. */
export function resolveAdviceCardsForPlan(
  planId: string,
  cmsAdviceCards: AdviceCard[] | undefined
): AdviceCard[] {
  const cardIds =
    planId === ELITE_PLANS_ELITE_PRIME_TAB_ID ? ELITE_PRIME_ADVICE_CARD_IDS : ELITE_ADVICE_CARD_IDS
  const chromeById = new Map((cmsAdviceCards ?? []).map((card) => [card.id, card]))

  return cardIds.map((cardId) => {
    const chrome = chromeById.get(cardId)
    if (!chrome) {
      return { id: cardId, title: '', body: '' }
    }
    return { ...chrome, id: cardId }
  })
}
